// @flow
import * as React from 'react';
import BoardCollageImage from 'app/common/react/components/profile/ProfileBoardCard/BoardCollageImage';
import CoverImage from 'app/common/react/components/profile/ProfileBoardCard/CoverImage';
import type { Image as ImageType } from 'app/packages/pinterest-flow-types/image';
import { Collage, Mask } from 'gestalt';

type Props = {|
  boardThumbs: Array<ImageType>,
  cover?: {
    isCustom?: boolean,
    position?: { height: number, width: number, x: number, y: number },
    url: string,
  },
  coverPin?: Object,
  height: number,
  numCols: 3 | 4,
  width: number,
|};

const COLLAGE_GUTTER_IN_PX = 2;

// This function was inspired by the answer given here:
//
//     https://stackoverflow.com/a/8831937
//
// It's just meant to produce a stable number for a given string.
const fasthash = (str) => {
  let hash = 0;
  if (str.length === 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash &= hash;
  }
  return Math.abs(hash);
};

export default function WideBoardCollage({
  boardThumbs,
  coverPin,
  cover,
  height,
  numCols,
  width,
}: Props) {
  const gridCols = !!cover ? Math.floor(numCols / 2) : numCols;
  const key = boardThumbs
    .slice(0, 2 * gridCols)
    .map((item) => item.url || '')
    .sort()
    .join('');
  const layoutKey = fasthash(key) % gridCols;
  return (
    <Mask shape="rounded" width={width} height={height}>
      <Collage
        columns={numCols}
        cover={!!cover}
        gutter={COLLAGE_GUTTER_IN_PX}
        height={height}
        layoutKey={layoutKey}
        renderImage={({ index, width, height }) => {
          if (index === 0 && !!cover) {
            return (
              <CoverImage
                customCover={cover.isCustom}
                height={height}
                imgUrl={cover.url}
                imgPos={
                  cover.position || {
                    width: 0,
                    height: 0,
                    x: 0,
                    y: 0,
                  }
                }
                width={width}
              />
            );
          } else {
            return (
              <BoardCollageImage
                height={height}
                image={boardThumbs[!!cover ? index - 1 : index]}
                width={width}
              />
            );
          }
        }}
        width={width}
      />
    </Mask>
  );
}

WideBoardCollage.defaultProps = {
  boardThumbs: [],
  height: 200,
  width: 300,
  numCols: 3,
};
